import { Pipe, PipeTransform } from '@angular/core';
import { DirectionTypeEnum } from '@zaoblako/shared/modules/catalog/enums/direction.type.enum';

const directionTypeNames: Record<DirectionTypeEnum, string> = {
  [DirectionTypeEnum.PERCENT]: 'Процент',
  [DirectionTypeEnum.CONSOLIDATED_AMOUNT]: 'Консолидированная сумма',
  [DirectionTypeEnum.AMOUNT]: 'Сумма',
  [DirectionTypeEnum.CONSOLIDATED_PERCENT]: 'Консолидированный процент'
};

@Pipe({
  standalone: true,
  name: 'directionTypeName'
})
export class DirectionTypeNamePipe implements PipeTransform {
  public transform(directionType: DirectionTypeEnum): string {
    return directionTypeNames[directionType];
  }
}
